module.exports = __webpack_public_path__ + "img/eac-hov.0ff9427d.svg";